import { m } from 'framer-motion';
// next
import NextLink from 'next/link';
// @mui
import { styled } from '@mui/material/styles';
import { Box, Button, Typography, Container, Stack } from '@mui/material';
// layouts
import Layout from '../layouts';
// components
import Page from '../components/Page';
import { MotionContainer, varBounce } from '../components/animate';
// assets
import { SeverErrorIllustration } from '../assets';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { datadogLogs } from '@datadog/browser-logs';
import { signOut } from 'next-auth/react';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  height: '100%',
  alignItems: 'center',
  paddingTop: theme.spacing(15),
  paddingBottom: theme.spacing(10),
}));

// ----------------------------------------------------------------------

Page500.getLayout = function getLayout(page: React.ReactElement) {
  return <>{page}</>;
};

// ----------------------------------------------------------------------

export default function Page500() {
  const { query, push } = useRouter();
  const errorCode = query['errorCode'];

  useEffect(() => {
    if (errorCode === 'token-invalid') {
      datadogLogs.logger.error(
        'Invalid token. User is missing user type attribute'
      );
    }
  }, [errorCode]);

  return (
    <Page title="500 Internal Server Error" sx={{ height: 1 }}>
      <RootStyle>
        <Container component={MotionContainer}>
          <Box sx={{ maxWidth: 480, margin: 'auto', textAlign: 'center' }}>
            {errorCode === 'token-invalid' && (
              <Stack gap={1}>
                <Box>An error has occurred with your account.</Box>
                <Box>Please try logging out and then logging back in.</Box>
                <Box>If the issue persists, contact the administrator.</Box>
                <Button
                  size="large"
                  variant="contained"
                  onClick={() =>
                    signOut({ redirect: true, callbackUrl: '/' }).then(() =>
                      push('/auth/login')
                    )
                  }
                >
                  Log out
                </Button>
              </Stack>
            )}
            {!errorCode && (
              <>
                <m.div variants={varBounce().in}>
                  <Typography variant="h3" paragraph>
                    500 Internal Server Error
                  </Typography>
                </m.div>
                <Typography sx={{ color: 'text.secondary' }}>
                  There was an error, please try again later.
                </Typography>
                <m.div variants={varBounce().in}>
                  <SeverErrorIllustration
                    sx={{ height: 260, my: { xs: 5, sm: 10 } }}
                  />
                </m.div>
                <NextLink href="/">
                  <Button size="large" variant="contained">
                    Go to Home
                  </Button>
                </NextLink>
              </>
            )}
          </Box>
        </Container>
      </RootStyle>
    </Page>
  );
}
